import { BannerPropsMicrocopy } from '../../molecules/Banner';
import {
  WriteReviewTipsPropsActions,
  WriteReviewTipsPropsMicrocopy,
} from '../../molecules/WriteReviewTips';

export const MAX_TITLE_CHARS = 60;

export type ProductMetadata = {
  upm: {
    packageVersion: string;
  };
};

export type WriteReviewModalPropsMicrocopy = {
  title: string;
  version: string;
  ownedDate: string;
  rateExperience: string;
  titleReview: string;
  titleReviewPlaceholder: string;
  writeReview: string;
  writeReviewPlaceholder: string;
  tips: WriteReviewTipsPropsMicrocopy;
  cancel: string;
  submit: string;
  close: string;
  remaining: string;
  remainingTitle: string;
  ratingValidationMessage: string;
  titleValidationMessage: string;
  reviewValidationMessage: string;
  multiPackageAsset: string;
  serverMessage?: BannerPropsMicrocopy;
};

export type WriteReviewModalPropsData = {
  title: string;
  imageUrl: string;
  version: string;
  ownedDate: string;
  isMultiPackage: boolean;
  productId?: string;
  data?: ReviewFormData;
};

export type WriteReviewModalPropsWithMicrocopy = WriteReviewModalPropsData & {
  microcopy: WriteReviewModalPropsMicrocopy;
};

export type ReviewFormData = {
  id: string;
  rating: number;
  title: string;
  body: string;
  productMetadata: ProductMetadata;
  lastUpdatedAt: string;
};

export type WriteReviewModalPropsActions = WriteReviewTipsPropsActions & {
  onSubmitReview: (
    productId: string,
    data: ReviewFormData,
    lastUpdatedAt?: string
  ) => Promise<void>;
};

export type WriteReviewModalProps = WriteReviewModalPropsWithMicrocopy &
  WriteReviewModalPropsActions & {
    reviewModalTrigger?: React.ReactNode;
    className?: string;
  };
